export default __webpack_public_path__ + "static/media/unblock-50px-8B8B8B.fffde66c.svg";